import { Button } from '@material-ui/core'
import { useRouterContext } from '@speedlo/hooks'
import React from 'react'

interface IProps {
  to: string
}

export const LinkButton: React.FC<IProps> = ({ to, children }) => {
  const { history } = useRouterContext()
  return <Button onClick={() => history.push(to)}>{children}</Button>
}
